export const environment = {
  production: true,
  buildId: '194311001028971',
};
